import { Accessor, Match, Switch } from "solid-js";
import { clientIdConfig } from "~/data/partner_config";
import RNRCodeHubbleBranding from "~/components/login-rnr/rnr_code_hubble_branding";

export function LoginPageBranding$Client(props: {
  clientId: Accessor<string | undefined>;
}) {
  return (
    <Switch>
      <Match when={props.clientId() === clientIdConfig.axisClientId}>
        <div class="absolute bottom-[10px]  ">
          <RNRCodeHubbleBranding />
        </div>
      </Match>
      <Match when={props.clientId() === clientIdConfig.bajajClientId}>
        <div class="absolute bottom-[10px]  ">
          <RNRCodeHubbleBranding />
        </div>
      </Match>
      <Match when={props.clientId() === clientIdConfig.tdClientId}>
        <div class="absolute bottom-0 left-0  right-0  flex h-[63px] flex-col items-center justify-center md:bg-black">
          <RNRCodeHubbleBranding />
          <p class="hidden text-center text-medium text-textNormal md:block">
            This portal is developed by Hubble money for TATA digital
          </p>
        </div>
      </Match>
    </Switch>
  );
}
